import React from 'react';

const Copyright = () => (
  <p className="mt-8 text-base text-gray-400 md:mt-0 md:order-1">
    Copyright &copy; 2021 Skyint Ltd. All rights reserved.
  </p>
);

export { Copyright };
